<template>
  <div>
    <div class="item" v-for="(item, i) in dataList" :key="i">
      <div class="item-top">
        <div class="item-top_l">
          <span class="tag"></span>
          <div class="txt">
            <span class="star" v-if="item.isOperate">*</span
            >{{ flowTypeLabel[item.flowType] }}
          </div>
        </div>
        <div class="item-top_r">{{ formatType(item) }}</div>
      </div>
      <div class="item-user">
        <div class="user-box">
          <!-- 上级审批 -->
          <template v-if="item.rangeType == 'superior'">
            <default-icon :types="1" />
          </template>
          <template v-else>
            <div
              class="user-item"
              v-for="(items, k) in item.selectedUserList"
              :key="items.userId"
            >
              <img
                class="user-item_icon"
                :src="
                  items.headUrl || require('@/assets/image/avatar/T_man.png')
                "
              />
              <span class="user-item_name">{{ items.userName }}</span>
              <img
                :src="del"
                class="user-item_del"
                v-if="item.isOperate"
                @click="delUser(i, k)"
              />
            </div>
            <template
              v-if="
                item.isOperate &&
                (item.chooseNumber == 'more' ||
                  (item.chooseNumber == 'one' &&
                    item.selectedUserList.length < 1))
              "
            >
              <default-icon :types="2" @click="addUser(i)" />
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import defaultIcon from "../../common/default-icon.vue";
import delIcon from "../../images/icon-quxaio.svg";

// import { ref, toRefs, watch } from "vue";
export default {
  name: "edit-item",
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    list: {
      deep: true,
      immediate: true,
      handler: function (e) {
        console.log(e);
        this.dataList = e;
      }
    }
  },
  data() {
    return {
      del: delIcon,
      dataList: [],
      flowTypeLabel: {
        approve: "审批",
        cc: "抄送"
      }
    };
  },
  components: { defaultIcon },
  methods: {
    formatType(item) {
      // approveType 审批类型[流程类型为审批][single:单人依次,jointly:会签,or:或签]
      const approve = {
        single: "人",
        jointly: "会签",
        or: "或签"
      };
      const { rangeType, approveType, selectedUserList } = item;
      // 指定成员
      if (rangeType == "assign") {
        return selectedUserList.length + approve[approveType];
      }
      // 发起人自选
      if (rangeType == "customize") {
        return `发起人自选${selectedUserList.length + approve[approveType]}`;
      }
      // 上级审批
      if (rangeType == "superior") {
        return `上一节点审批人指定`;
      }
      return "";
    },
    delUser(i, k) {
      const target = this.dataList[i];
      target.selectedUserList.splice(k, 1);
      this.dataList[i] = target;
      // this.$set(this.dataList, i, target);
    },
    addUser(i) {
      this.$emit("add-user", this.callback, i);
    },
    callback(list, i) {
      const target = this.dataList[i];
      target.selectedUserList = [...target.selectedUserList, ...list];
      this.$set(this.dataList, i, target);
    }
  }
  // setup(props, { emit }) {
  //   const { list } = toRefs(props);

  //   const dataList = ref([]);
  //   watch(
  //     list,
  //     (list) => {
  //       dataList.value = list;
  //     },
  //     {
  //       immediate: true,
  //       deep: true,
  //     }
  //   );

  //   const del = ref(delIcon)
  //   const formatType = (item) => {
  //     // approveType 审批类型[流程类型为审批][single:单人依次,jointly:会签,or:或签]
  //     const approve = {
  //       single: "人",
  //       jointly: "会签",
  //       or: "或签",
  //     };
  //     const { rangeType, approveType, selectedUserList } = item;
  //     // 指定成员
  //     if (rangeType == "assign") {
  //       return selectedUserList.length + approve[approveType];
  //     }
  //     // 发起人自选
  //     if (rangeType == "customize") {
  //       return `发起人自选${selectedUserList.length + approve[approveType]}`;
  //     }
  //     // 上级审批
  //     if (rangeType == "superior") {
  //       return `上一节点审批人指定`;
  //     }
  //     return "";
  //   };
  //   const delUser = (i, k) => {
  //     const target = dataList.value[i];
  //     target.selectedUserList.splice(k, 1);
  //     // this.$set(this.dataList, i, target);
  //     dataList.value[i] = target
  //   };
  //   const addUser = (i) => {
  //     emit("add-user", callback, i);
  //   };
  //   const callback = (list, i) => {
  //     const target = dataList.value[i];
  //     target.selectedUserList = [...target.selectedUserList, ...list];
  //     dataList.value[i] = target
  //   };

  //   return {
  //     dataList,
  //     del,
  //     formatType,
  //     delUser,
  //     addUser,
  //     callback,

  //   };
  // },
};
</script>
<style lang="less" scoped>
.item {
  width: 100%;
  min-height: 85px;
  box-sizing: border-box;
  padding: 0 12px;
  &:nth-last-of-type(1) {
    .item-user {
      &::before {
        display: none;
      }
    }
  }
  &-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 20px;
    &_l {
      display: flex;
      align-items: center;
      padding-left: 17px;
      position: relative;
      .tag {
        display: inline-block;
        width: 9px;
        height: 9px;
        background: #d8d8d8;
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
      }
      .txt {
        font-size: 15px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #333333;
        .star {
          font-weight: 400;
          text-align: left;
          color: #fe4f54;
        }
      }
    }
    &_r {
      font-size: 13px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #999999;
    }
  }
  &-user {
    min-height: 85px;
    position: relative;
    padding: 16px 12px;

    &::before {
      display: inline-block;
      content: "";
      height: calc(100% + 40rpx);
      border-left: 1px solid #d8d8d8;
      position: absolute;
      left: 4px;
      top: -5px;
      z-index: 1;
    }

    .user-box {
      display: flex;
      flex-wrap: wrap;

      .user-item {
        position: relative;
        height: 64px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-right: 12px;
        margin-bottom: 14px;
        &:nth-of-type(6n) {
          margin-right: 0;
        }
        &_del {
          position: absolute;
          top: -8px;
          right: 1px;
          z-index: 1;
          display: inline-block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
        }
        &_icon {
          display: inline-block;
          height: 44px;
          width: 44px;
          border-radius: 50%;
          overflow: hidden;
        }
        &_name {
          display: inline-block;
          width: 44px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          font-size: 13px;
          font-weight: 400;
          text-align: left;
          color: #333333;
        }
      }
    }
  }
}
</style>
